import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import * as $ from 'jquery';
import { LinkService } from '../../../_services/langhfre.service';
import { ActivatedRoute } from '@angular/router';
import { WebsiteService } from 'src/app/_services/website.service';
import { LoadScriptService } from 'src/app/_services/load-script.service';
declare function ire(string,{}): any;
@Component({
  selector: 'app-credits',
  templateUrl: './credits.component.html',
  styleUrls: ['./credits.component.scss']
})
export class CreditsComponent implements OnInit {
  country: string;
  encodedData: any;
  decodedData: any;
  premiumDecodedData: any;
  paymentModeOption: any;
  premiumUserpaymentModeOption: any;
  twentyPackFinalAmount: any;
  constructor(
    private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    private route: ActivatedRoute,
    public paymentService: WebsiteService,
    public loadScript: LoadScriptService
  ) { }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      if (localStorage.getItem("country-trinka") == null || localStorage.getItem("country-trinka") == "") {
        this.loadGeoAPIScript();
      }
    }
    this.titleService.setTitle('크레딧으로 트링카 기능을 유연하게 사용하기');
    this.metaTagService.updateTag({ name: 'description', content: "트링카의 많은 추가 기능은 크레딧을 사용합니다. 크레딧을 활용하여 이러한 기능을 사용하고 필요에 따라 더 많은 크레딧을 구입하실 수 있습니다." });
    this.metaTagService.updateTag({ property: 'og:title', content: '크레딧으로 트링카 기능을 유연하게 사용하기' });
    this.metaTagService.updateTag({ property: 'og:description', content: "트링카의 많은 추가 기능은 크레딧을 사용합니다. 크레딧을 활용하여 이러한 기능을 사용하고 필요에 따라 더 많은 크레딧을 구입하실 수 있습니다." });
    this.metaTagService.updateTag({ property: 'og:url', content: 'https://www.trinka.ai/kr/features/credits' });
    this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
    this.metaTagService.updateTag({ property: 'og:image', content: 'https://www.trinka.ai/assets/images/CreditInformation.png' });
    this.metaTagService.updateTag({ name: 'language', content: 'ko-kr' });
    this.metaTagService.updateTag({ name: 'twitter:title', content: '크레딧으로 트링카 기능을 유연하게 사용하기' });
    this.metaTagService.updateTag({ name: 'twitter:description', content: "트링카의 많은 추가 기능은 크레딧을 사용합니다. 크레딧을 활용하여 이러한 기능을 사용하고 필요에 따라 더 많은 크레딧을 구입하실 수 있습니다." });
    this.metaTagService.updateTag({ name: 'twitter:image', content: 'https://www.trinka.ai/assets/images/CreditInformation.png' });
    this.LinkService.addTag({ rel: 'canonical', href: 'https://www.trinka.ai/kr/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/features/credits' });
    this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/features/credits' });

    if (isPlatformBrowser(this.platformId)) {
      // $.getScript('../../../assets/js/particles.min.js', function(){});
      $.getScript('../../../assets/js/wisepop.js', function () { });
    }
    this.country = localStorage.getItem("country-trinka") ? localStorage.getItem("country-trinka") : "en";
      console.log(this.country);
      this.route.params.subscribe(params => {
        this.encodedData = params['id'];
        this.paymentService.getPlans(this.encodedData,3).subscribe(resp => {
          if (resp['message'] == 'success') {
            this.decodedData = resp['data']
            this.paymentModeOption = this.decodedData;
            // console.log("Country is: ",this.country);
            console.log("Data", this.decodedData);
            // console.log("Final Amount: ",this.decodedData[2].final_amount);
            // var twentyPack = this.decodedData[3].amount;
            // this.twentyPackFinalAmount = twentyPack / this.decodedData[3].discount * 100;
            // console.log(twentyPack);
            // console.log("twentyPack Final Amount", this.twentyPackFinalAmount);
          }
        });
      });

      this.route.params.subscribe(params => {
        this.encodedData = params['id'];
        this.paymentService.premiumGetPlan(this.encodedData,3).subscribe(resp => {
          if (resp['message'] == 'success') {
            this.premiumDecodedData = resp['data']
            this.premiumUserpaymentModeOption = this.premiumDecodedData;
            // console.log("Country is: ",this.country);
            console.log("Premium user Data: ", this.premiumDecodedData);
            // console.log("Final Amount: ",this.decodedData[2].final_amount);
            // var twentyPack = this.decodedData[3].amount;
            // this.twentyPackFinalAmount = twentyPack / this.decodedData[3].discount * 100;
            // console.log("twentyPack Final Amount", this.twentyPackFinalAmount);
          }
        });
      });
      

  }

  loadGeoAPIScript() {
    if (isPlatformBrowser(this.platformId)) {
      var scriptName = "geoIP"
      this.loadScript.loadScript(scriptName, '//geoip-js.com/js/apis/geoip2/v2.1/geoip2.js')
        .then(() => {
          console.log(`${scriptName} loaded successfully`);
          var onSuccess = function (location) {
            localStorage.setItem("country-trinka", location['country']['iso_code'])
          };

          var onError = function (error) {
            localStorage.setItem("country-trinka", "IN")
          };
          try {
            //@ts-ignore
            geoip2.city(onSuccess, onError);
          } catch (error) {
            console.log(error)
          }
        })
        .catch(() => {
          console.error(`Failed to load ${scriptName}`);
        });
    }
  }

  perMonth: any;
  perMonthAfterDis: any;
  calculatePlan(finalAmt, credits) {    
    this.perMonthAfterDis = finalAmt / credits
    return parseFloat(this.perMonthAfterDis).toFixed(2);
  }
  calculateDiscount(annualAmt, finalAmt, credits) {
    let actualAmt = annualAmt * credits / (2)
    let perMonthAfterDis: any = ((actualAmt - finalAmt) * 100) / (actualAmt);
    return parseFloat(perMonthAfterDis).toFixed(0);
  }
  calculateDiscountFinal(originalAmt, finalAmt, credits) {
    const originalTotal = originalAmt * credits;
    const discount = ((originalTotal - finalAmt) * 100) / originalTotal;
    return Math.round(discount);
  }
  scroll(el: HTMLElement) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
  ngAfterViewInit() {
    if (isPlatformBrowser(this.platformId)) {
      $.getScript('../../../../assets/js/home_client_slider.js', function () { });
      $('#closedPopup, #wordPluginPopup').click(function () {
        $('iframe.youtubeVideoForTryDemo').remove()
      });

      $('#VewiVideoSection').click(function () {
        if (!$('#iframe').length) {
          $('#iframeHolder').html('<iframe class="youtubeVideoForTryDemo" id="iframe" src="https://www.youtube.com/embed/5KsBh4PQUPI" width="100%" height="450"></iframe>');
        }
      });

    }
  }

  generateGuid() {
    var result, i, j;
    result = '';
    for(j=0; j<32; j++) {
      if( j == 8 || j == 12 || j == 16 || j == 20)
        result = result + '-';
      i = Math.floor(Math.random()*16).toString(16).toUpperCase();
      result = result + i;
    }
    return result;
  }
}
